// src/hooks/userCurrentUid.js

import { useAccount } from "../context/AccountContext";

export const useCurrentUid = () => {
  const { currentAccount } = useAccount();
  // Return the CURRENTLY SELECTED account UID, not the auth user
  return currentAccount?.uid || null;
};
